<template>
  <div>
    <el-form
        ref="deleteAccForm"
        :model="accountDeletionForm"
        :rules="formRules"
        @submit.native.prevent>
      <el-form-item prop="password" class="!mb-0">
        <el-input v-model="accountDeletionForm.password" name="password" type="password"></el-input>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
export default {
  name: 'AccountDeletionForm',
  data() {
    return {
      accountDeletionForm: {
        password: '',
      },
      formRules: {
        password: [{ required: true, message: 'Password is required', trigger: 'blur' }],
      },
    }
  },
  methods: {
    validateForm() {
      this.$refs.deleteAccForm.validate(valid => {
        if (valid) {
          this.$emit('form-valid', this.accountDeletionForm.password)  // Emitting the event when form is valid
        } else {
          console.error('Form validation failed.')
          return false
        }
      })
    },
  },
}
</script>